class ProductsGridVSO extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.products-grid-vso__quick-add-btn');
    this.init();
  }

  init() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleQuickAdd.bind(this));
    });
  }

  async handleQuickAdd(e) {
    e.preventDefault();
    const button = e.currentTarget;

    button.classList.add('loading');
    button.disabled = true;

    try {
      const productUrl = button.dataset.productUrl;

      const productData = await this.fetchProductData(productUrl);

      if (!productData || !productData.variants) {
        throw new Error('Product data not found');
      }

      const defaultVariant = productData.variants[0];

      if (!defaultVariant) {
        throw new Error('No variant found for this product');
      }

      await this.addToCart(defaultVariant.id);

    } catch (error) {
      this.showError(button);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  async fetchProductData(productUrl) {
    try {
      const response = await fetch(`${productUrl}.js`);
      if (!response.ok) throw new Error('Failed to fetch product');
      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async addToCart(variantId) {
    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);
      formData.append("sections", sectionsToBundle.join(","));
      formData.append("sections_url", `${window.Shopify.routes.root}variants/${variantId}`);

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to add to cart');
      }

      const result = await cartResponse.json();

      const cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json());
      cartData["sections"] = result["sections"];

      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          cart: cartData
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartData
        }
      }));

    } catch (error) {
      throw error;
    }
  }

  showError(button) {
    const originalContent = button.innerHTML;
    button.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    setTimeout(() => {
      button.innerHTML = originalContent;
    }, 2000);
  }
}

if (!customElements.get('products-grid-vso')) {
  customElements.define('products-grid-vso', ProductsGridVSO);
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.products-grid-vso')) {
      const section = event.target.querySelector('.products-grid-vso');
      if (section && !customElements.get('products-grid-vso')) {
        customElements.define('products-grid-vso', ProductsGridVSO);
      }
    }
  });
}
